const main = `<div> <p class="c-title">尊敬的站長</p> <p>你好！ </p> <p>&nbsp; &nbsp; 經過近6個多月的完善，當前SaaS已全部切換到4.0全新架構，轉化率和留存率都有不少提升，為幫助站長降低成本，將推出以下活動（長期有效）： </p> <p> <span style="color: #000000;font-weight: bold;">&nbsp; &nbsp; 1、全額返還開站費：</span> 凡是於2024年2月20日之後所建立的站點（即新收費模式），只要單一站點<span style="color:#ff8800">當月賬單達30萬U或單一站點累積總賬單達150萬U，即可全額返還所收取的開站費</span> （於下面活動重疊時，最多只退還100%，不能超額退還）。 </p> <p> <span style="color: #000000;font-weight: bold">&nbsp; &nbsp; 2、退還開站費情形：</span> 若不符合上述條件，仍可透過以下方式減免開站費。  </p> <p> <span style="color：#000000;font-weight: bold">&nbsp; &nbsp; （1）亞太系統：</span> 2024年1月30日之後創建的亞太站點，當該站點運營到90天後，期間準時繳付賬單，並且日平均儲值達到10萬rmb的，可申請退還25%（即5000U）開站費； 當該站點運營到180天後，期間準時繳付賬單，且日平均儲值達到15萬rmb的，可再申請退還50%（即10000U）的開站費， <span style="color:#ff8800">相當於實際只收取25%（即5000U）的開站費。 </span> </p> <p> <span style="color：#000000;font-weight: bold">&nbsp; &nbsp;（2）美洲系統：</span> 2024年6月1日後創建的美洲站點（4.0版本之後），當該站點運營到90天後，期間準時繳付賬單，並且日平均儲值達到20萬BRL的，可申請退還25%（即5000U）開站費；當該站點運營到180天後，期間準時繳付賬單，並且日平均儲值達到30萬BRL的，可再申請退還50%（即10000U）的開站費， <span style="color:#ff8800">相當於實際只收取25%（即5000U）的開站費。 </span> </p> <p> <span style="color：#000000;font-weight: bold">&nbsp; &nbsp;3、遷移免開站費：</span> 屬於外部站點遷移到WG平台的，導入的有效會員≥1萬人，且前30天日平均儲值≥50萬rmb， <span style="color:#ff8800">則30天後可申請退還20000U的開站費到站點餘額，用於賬單抵扣。 </span> </p> <p> <span style="color：#000000;font-weight: bold">&nbsp; &nbsp;4、新站免維護費：</span> 所有新開的站點，建站完成後的前30天免維護費，統一第31天才開始計算收取3000U/月的維護費。 </p> <p> <span style="color：#000000;font-weight: bold">&nbsp; &nbsp;5、免押金情形：</span> 若有月賬單金額超10萬U且準時繳付的大業主願意擔保，則創建站點時可申請免繳9000U/站點的押金。 </p> <p> <span style="font-weight: bold;color: #37bc2a;">&nbsp; &nbsp;6、返利和免維護費【重要】</span> </p> <p> <span style="color: #000000;font-weight: bold">&nbsp; &nbsp; （1）免維護費情形：</span> 當月該站點賬單為0-1萬U則全額收取維護費3000U /月；當月該站點賬單為1-5萬U則只收取維護費2000U/月；<span style="color: #008000">當月該站點賬單為5-10萬U則只收取維護費1000U/月；</span> 當月該站點賬單為10萬U以上則免收取維護費，即為0。 </p> <p> <span style="color: #000000;font-weight: bold">&nbsp; &nbsp; （2）舊規則優惠（最高1.2%）：</span> 指2024年2月20日之前創建的站點，站點賬單金額決定三方遊戲的優惠比例，共分為8個階梯， <span style="color: #008000">最高可以優惠1.2%（即當月該站點賬單金額100萬U以上時，PG原收費7%將變為7%-1.2%=5.8%）；</span> 若目前已享有固定三方優惠，則系统自動以最高等級計算，例如：某站點當月賬單優惠為8萬U，表格對應優惠比例為0.4%，若集團已享有三方的固定優惠為0.7%，則以最大的優惠為準直接以0.7%計算（即PG由7%變成6.3%）。 </p> <p> <span style="color: #000000;font-weight: bold">&nbsp; &nbsp; （3）新規則優惠（最高2.3%）：</span> 指2024年2月20日後創建的站點，站點賬單金額決定三方遊戲的優惠比例，共分為8個階梯， <span style="color: #008000">最高可以優惠2.3%（即當月該站點賬單金額100萬U以上時，PG原收費9%將變為9%-2.3%=6.7%）；</span> 若目前已享有固定三方優惠，則系統自動以最高等級計算，例如：某站點當月賬單優惠為4萬U，表格對應優惠比例為0.5%，若集團已享有三方的固定優惠為1.0%，則以最大的優惠為準直接以1.0%計算（即PG由9%變成8%）。  </p><p> <span style="color: #000000;font-weight: bold">&nbsp; &nbsp; （4）優惠比例對照表：如下圖</span> </p><table style="width:100%" class="wg-table-style">
 <thead style="background-color: rgba(22, 120, 255, 0.04)">
 <tr>
 <th>階梯</th>
 <th>當月單站點賬單</th>
 <th>
 <div>舊政策優惠比例</div>
 <div style="font-weight:normal">
 (於24年2月20日之前創建的站點)
 </div>
 </th>
 <th>
 <div>新政策優惠比例</div>
 <div style="font-weight:normal">
 (於24年2月20日之後創建的站點)
 </div>
 </th>
 <th>月維修費</th>
 </tr>
 </thead>
 <tbody style="text-align:center;line-height:2;">
 <tr>
 <td>1檔</td>
 <td>0~1萬U</td>
 <td>0.00%</td>
 <td>0.00%</td>
 <td>3000U</td>
 </tr>
 <tr>
 <td>2檔</td>
 <td>1~5萬U</td>
 <td>0.30%</td>
 <td>0.50%</td>
 <td>2000U</td>
 </tr>
 <tr>
 <td>3檔</td>
 <td>5~10萬U</td>
 <td>0.50%</td>
 <td>1.00%</td>
 <td>1000U</td>
 </tr>
 <tr>
 <td>4檔</td>
 <td>10~30萬U</td>
 <td>0.80%</td>
 <td>1.50%</td>
 <td>免維護費</td>
 </tr>
 <tr>
 <td>5檔</td>
 <td>30~50萬U</td>
 <td>1.00%</td>
 <td>2.00%</td>
 <td>免維護費</td>
 </tr>
 <tr>
 <td>6檔</td>
 <td>50~75萬U</td>
 <td>1.05%</td>
 <td>2.10%</td>
 <td>免維護費</td>
 </tr>
 <tr>
 <td>7檔</td>
 <td>75~100萬U</td>
 <td>1.10%</td>
 <td>2.20%</td>
 <td>免維護費</td>
 </tr>
 <tr>
 <td>8檔</td>
 <td>100萬U以上</td>
 <td>1.20%</td>
 <td>2.30%</td>
 <td>免維護費</td>
 </tr>
 </tbody>
 </table> <p> <span style="color: #000000;font-weight: bold">&nbsp; &nbsp; 7、被回收優惠情形：</span> 若經常性拖欠賬單超過30天的，則WG有權回收所有優惠。 </p> <p> <span style="color: #000000;font-weight: bold">&nbsp; &nbsp; 8、自營遊戲完全免費預告：</span> 經過近6個月的優化，自營遊戲不管在穩定性、加載速度、數值留存都有了很大的提升，且支持調整殺率共有3.5%、4.0%和4.5%三檔（僅支持電子），同時增加組團瓜分彩金池的功能，只能在同一站點進行組隊，可協助站點進行裂變；為了慶祝遊戲重大變革， <span style="color: #008000">自2024年7月1日起至2024年8月31日，WG自營遊戲「棋牌、電子、捕魚和區塊鏈」將為期2個月完全免交收，且期間因遊戲漏洞導致的虧損將給予全額賠償。 </span> </p> <p> <span style="color: #000000;font-weight: bold">&nbsp; &nbsp; 9、新遊戲公告：</span> 根據巴西市場的喜好，WG自營遊戲已新增幾款玩法接近的熱門遊戲<span style="color: #eb05f2">（巨富鳥、海龜先生、金錢豹、尋龍奪寶、旺財狗），</span> <span style="color:#ff8800">不僅為期兩個月完全免費</span> （2024年7月1日-2024年8月31日），且定價永久固定只抽5% </p> <p> <span style="color: #000000;font-weight: bold">&nbsp; &nbsp; 10、PG印度市場9折：</span> PG官方將針對印度市場舉辦活動，活動期間賬單享有9折優惠，活動時間從2024年7月1日至2025年6月31日，僅限PG遊戲印度盧比（INR）幣種的賬單可享9折，例如原來收費8%，折扣後收費7.2%。 </p> <p> <span style="color: #000000;font-weight: bold">&nbsp; &nbsp; 11、全面放開美洲系統：</span> 因先前系統架構存在瓶頸，導致WG不敢對外開放美洲系統，現已全面切換至4.0架構，至少可承載1億人同時在線，所以全面開放美洲系統建站，歡迎推介，推介人最高可享受淨利潤6%的返佣，被推薦人可享有2.5%賬單折扣，有效期限為前6個月的賬單。 </p> <p style="margin-top:20px;">此致</p> <div style="text-align:right;margin-top:10px;"> <div>商祺！致謝！ </div> <div>WG元宇宙團隊</div> <div>2024年7月20日更新</div> </div> </div>`
export default main